<template>
    <div class="bus-box">
        <div class="bus-box-bg"></div>
        <el-row class="bus-box-you bus-box-common">
            <h3>
                <span>
                    <img src="../../assets/images/bus-icon-left.png">
                </span>
                澳洲留学优势
                <span>
                    <img src="../../assets/images/bus-icon-right.png">
                </span>
            </h3>
            <el-row class="bus-box-you-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in youList" :key="index" :class="'bus-box-you-item'+index">
                    <img :src="item.src">
                    <h4>{{item.title}}</h4>
                    <p>{{item.desc}}</p>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="bus-box-rank-bg">
            <el-row class="bus-box-rank bus-box-common">
                <h3>
                    <span>
                        <img src="../../assets/images/bus-icon-left.png">
                    </span>
                    澳洲大学世界排名对比
                    <span>
                        <img src="../../assets/images/bus-icon-right.png">
                    </span>
                </h3>
                <el-row class="bus-box-rank-list">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="11">
                                世界排名
                            </el-col>
                            <el-col :span="13">
                                澳洲大学
                            </el-col>
                        </el-row>
                        <el-row class="bus-box-rank-item" v-for="(item,index) in schoolList1" :key="index">
                            <el-col :span="11">
                                {{item.rank}}
                            </el-col>
                            <el-col :span="13">
                                {{item.school}}
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="11">
                                世界排名
                            </el-col>
                            <el-col :span="13">
                                中国大学
                            </el-col>
                        </el-row>
                        <el-row class="bus-box-rank-item" v-for="(item,index) in schoolList2" :key="index">
                            <el-col :span="11">
                                {{item.rank}}
                            </el-col>
                            <el-col :span="13">
                                {{item.school}}
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-row>
        </el-row>
        <el-row class="bus-box-people bus-box-common">
            <h3>
                <span>
                    <img src="../../assets/images/bus-icon-left.png">
                </span>
                适合人群
                <span>
                    <img src="../../assets/images/bus-icon-right.png">
                </span>
            </h3>
            <el-row type="flex" justify="space-between" class="bus-box-people-list">
                <el-col>
                    <span>1</span>
                    <h4>国内成绩或学历一般的学生</h4>
                </el-col>
                <el-col>
                    <span>2</span>
                    <h4>在该领域已经有一定的专业技能或实践经验 的学生</h4>
                </el-col>
                <el-col>
                    <span>3</span>
                    <h4>经济条件一般的工薪阶层</h4>
                </el-col>
                <el-col>
                    <span>4</span>
                    <h4>以“移民”为主要目的的学生</h4>
                </el-col>
            </el-row>
            <el-row class="bus-box-tiao bus-box-common">
                <img src="../../assets/images/bus-tiao-bg.png" class="bus-box-tiao-bg">
                <h3>
                    <span>
                        <img src="../../assets/images/bus-icon-left.png">
                    </span>
                    招生条件
                    <span>
                        <img src="../../assets/images/bus-icon-right.png">
                    </span>
                </h3>
                <el-row class="bus-box-tiao-list">
                    <el-row class="bus-box-tiao-item">
                        <el-col :span="1">1</el-col>
                        <el-col :span="23">18至35 岁间，身体健康心理健全，无不良记录</el-col>
                    </el-row>
                    <el-row class="bus-box-tiao-item">
                        <el-col :span="1">2</el-col>
                        <el-col :span="23">高中/中技/中专，或以上学历</el-col>
                    </el-row>
                    <el-row class="bus-box-tiao-item">
                        <el-col :span="1">3</el-col>
                        <el-col :span="23">申请人及其直系亲属无澳洲拒签史，无非法滞留史</el-col>
                    </el-row>
                    <el-row class="bus-box-tiao-item">
                        <el-col :span="1">4</el-col>
                        <el-col :span="23">踏实肯干，适应能力强</el-col>
                    </el-row>
                    <el-row class="bus-box-tiao-item">
                        <el-col :span="1">5</el-col>
                        <el-col :span="23">有英语基础最好，没有基础可以培训</el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-row>
        <el-row class="bus-box-partner bus-box-common">
            <h3>
                <span>
                    <img src="../../assets/images/bus-icon-left.png">
                </span>
                直通车合作大学
                <span>
                    <img src="../../assets/images/bus-icon-right.png">
                </span>
            </h3>
            <el-row type="flex" class="bus-box-partner-list">
                <el-col>
                    <img src="../../assets/images/bus-partner-img11.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img1.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img2.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img3.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img4.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img5.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img6.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img7.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img8.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img9.png">
                </el-col>
                <el-col>
                    <img src="../../assets/images/bus-partner-img10.png">
                </el-col>
            </el-row>
        </el-row>
        <el-row class="bus-box-tips bus-box-common">
            <h3>
                <span>
                    <img src="../../assets/images/bus-icon-left.png">
                </span>
                澳洲留学办理流程
                <span>
                    <img src="../../assets/images/bus-icon-right.png">
                </span>
            </h3>
            <img src="../../assets/images/bus-tips-img.png" class="bus-box-tips-img">
        </el-row>
        <el-row class="bus-box-common bus-box-service">
            <h3>
                <span>
                    <img src="../../assets/images/bus-icon-left.png">
                </span>
                服务优势
                <span>
                    <img src="../../assets/images/bus-icon-right.png">
                </span>
            </h3>
            <el-row class="bus-box-service-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in serviceList" :key="index">
                    <img :src="item.src">
                    <div>
                        <h4>{{item.title}}</h4>
                        <p>{{item.desc.indexOf('荔枝生涯') !== -1 ? website.name ? item.desc.replace('荔枝生涯', website.name) : '荔枝生涯' : item.desc }}</p>
                    </div>
                </el-col>
            </el-row>
            <el-row class="bus-box-infor bus-box-order">
                <img src="../../assets/images/channel-order.png" alt="">
                <div>
                    <span class="bus-box-order-title">预约专家 免费咨询</span>
                    <span class="bus-box-order-desc">留下联系方式，立即与专家一对一</span>
                </div>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
import { mapState } from 'vuex'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            youList:[
                {src:require('../../assets/images/bus-you-icon1.png'),title:'国际认可',desc:'全球公认的最成功、最先进的教育体系之一'},
                {src:require('../../assets/images/bus-you-icon2.png'),title:'门槛低',desc:'入学条件为雅思5分，高中以上或等同于高中学历即可，语言不够，可配语言直升班'},
                {src:require('../../assets/images/bus-you-icon3.png'),title:'成本低',desc:'学费相当于大学学费的二分之一；学制一般1-2年，毕业后，可直接就业'},
                {src:require('../../assets/images/bus-you-icon4.png'),title:'可移民',desc:'完成2年学习可得1.5年的毕业生工作签证，加上半年等待期，有近2年在澳全职工作和进行移民准备'},
                {src:require('../../assets/images/bus-you-icon5.png'),title:'好就业',desc:'与企业界紧密关系，众多实习机会，利于积累行业经验和人脉，容易就业，薪资也高'},
            ],
            schoolList1:[
                {rank:'27',school:'澳洲国立大学'},
                {rank:'37',school:'墨尔本大学'},
                {rank:'38',school:'悉尼大学'},
                {rank:'43',school:'新南威尔士大学'},
                {rank:'47',school:'昆士兰大学'},
                {rank:'58',school:'蒙纳士大学'},
                {rank:'93',school:'西澳大学'},
                {rank:'108',school:'阿德莱德大学'},
                {rank:'133',school:'悉尼科技大学'},
                {rank:'193',school:'伍伦贡大学'},
            ],
            schoolList2:[
                {rank:'17',school:'清华大学'},
                {rank:'18',school:'北京大学'},
                {rank:'31',school:'复旦大学'},
                {rank:'45',school:'浙江大学'},
                {rank:'50',school:'上海交通大学'},
                {rank:'98',school:'中国科学技术大学'},
                {rank:'131',school:'南京大学'},
                {rank:'211',school:'同济大学'},
                {rank:'225',school:'武汉大学'},
                {rank:'236',school:'哈尔滨工业大学'},
            ],
            serviceList:[
                {src:require('../../assets/images/bus-service-icon1.png'),title:'团队优势',desc:'荔枝生涯顶级专家团队全程跟踪,一对一线上线下规划指导'},
                {src:require('../../assets/images/bus-service-icon2.png'),title:'流程优势',desc:'一站式服务、自我评估、目标定位、院校选择多重指导等'},
                {src:require('../../assets/images/bus-service-icon3.png'),title:'品牌保障',desc:'可靠的品牌支撑，实力、可信、靠谱'},
            ],
            formInline: {
                username: '',
                phone: '',
                type: '5'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },
    computed: {
        ...mapState({
            website: state => state.user.website
        })
    },
    mounted() {
        
    },

    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$width: 1200px;
$margin: 0 auto;
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$font-family: 'MicrosoftYaHei';
$margin: 0 auto;
.bus-box-bg {
    background: url('../../assets/images/bus-bg.jpg') no-repeat center;
    background-size: cover;
    height: 548px;
}
.bus-box-common {
    h3 {
        font-size: 46px;
        font-family: 'zihun443hao';
        font-weight: 100;
        text-align: left;
        color: #ffffff;
        line-height: 66px;
        letter-spacing: 4px;
        text-shadow: 0px 2px 4px 0px rgba(5,25,71,0.50); 
        text-align: center;
        margin: 0;
    }
}
.bus-box-you {
    background: url('../../assets/images/bus-you-bg.jpg') no-repeat center;
    background-size: cover;
    height: 877px;
    h3 {
        margin-top: 42px;
    }
    .bus-box-you-list {
        background: url('../../assets/images/bus-you-bg1.png') no-repeat center;
        background-size: cover;
        width: 1260px;
        height: 410px;
        margin: $margin;
        margin-top: 72px;
        font-family: $font-family;
        .el-col {
            width: 240px;
            text-align: center;
            font-weight: 400;
            position: relative;
            padding-left: 64px;
            box-sizing: border-box;
            img {
                margin-top: 40px;
            }
            h4 {
                font-size: 28px;
                text-align: center;
                color: #ffffff;
                line-height: 38px;
                margin:18px 0 14px 0;
            }
            p {
                font-size: 18px;
                color: #ffffff;
                line-height: 28px;
                text-align: left;
                margin: 0;
                letter-spacing: 1.5px;
            }
        }
        .bus-box-you-item1 {
            padding-left: 52px;
            left: -10px;
            top: 30px;
        }
        .bus-box-you-item2 {
            padding-left: 62px;
            left: -25px;
        }
        .bus-box-you-item3 {
            padding-left: 50px;
            left: -35px;
            top: 30px;
        }
        .bus-box-you-item4 {
            padding-left: 60px;
            left: -60px;
        }
    }
}
.bus-box-rank-bg {
    background: url('../../assets/images/bus-school-bg.jpg') no-repeat center;
    background-size: cover;
    height: 670px;
}
.bus-box-rank {
    width: $width;
    margin: $margin;
    height: 836px;
    background: rgba(239,244,250,0.92);
    border-radius: 20px;
    box-shadow: 0px 8px 20px 0px rgba(0,26,133,0.17), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(6px);
    margin-top: -222px;
    h3 {
        margin-top: 52px;
        color: #0054be;
    }
    .bus-box-rank-list {
        margin-top: 46px;
        >.el-col:not(:last-child) {
            border-right: 1px dashed #babece;
        }
        .el-col {
            text-align: center;
            font-size: 20px;
            font-family: $font-family;
            text-align: center;
            color: #332e2c;
            line-height: 26px;
            letter-spacing: 1.74px;
            .el-row {
                margin-bottom: 34px;
            }
            .el-col-13 {
                padding-right: 80px;
            }
        }
        .bus-box-rank-item {
            margin-bottom: 0!important;
            .el-col-11 {
                color: #ff7853;
                font-size: 28px;
                font-family: 'Impact';
                font-weight: 400;
                text-align: center;
                color: #ff7853;
                line-height: 34px;
                letter-spacing: 2.43px;
            }
            .el-col-13 {
                font-size: 24px;
                font-family: $font-family;
                font-weight: 700;
                text-align: center;
                color: #332e2c;
                line-height: 31px;
                letter-spacing: 2.09px;
                padding-right: 80px;
            }
        }
        .bus-box-rank-item:not(:last-child) {
            margin-bottom: 24px!important;
        }
    }
}
.bus-box-people {
    background: url('../../assets/images/bus-people-bg.jpg') no-repeat center;
    width: 100%;
    height: 850px;
    background-size: cover;
    h3 {
        margin: 49px 0 70px 0;
    }
    .bus-box-people-list {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            width: 587px;
            height: 120px;
            background: linear-gradient(270deg,#ff9d3a, #ff7a3f 100%);
            border-radius: 8px;
            box-shadow: 0px 8px 20px 0px rgba(0,4,101,0.20); 
            margin-bottom: 26px;
            display: flex;
            align-items: center;
            padding: 0 24px;
            span {
                display: inline-block;
                width: 50px;
                height: 50px;
                background: #ffffff;
                border-radius: 50%;
                font-size: 26px;
                font-family: 'Impact';
                font-weight: 400;
                text-align: justify;
                color: #ff823f;
                line-height: 50px;
                text-align: center;
            }
            h4 {
                font-size: 24px;
                font-weight: 600;
                color: #ffffff;
                line-height: 40px;
                margin-left: 24px;
            }
        }
    }
}
.bus-box-tiao {
    background: #fff;
    width: $width;
    height: 586px;
    margin: $margin;
    border-radius: 20px;
    margin-top: 77px;
    position: relative;
    z-index: 99;
    .bus-box-tiao-bg {
        position: absolute;
    }
    h3 {
        color: #0054be;
        margin: 0;
        margin-top: 52px;
    }
    .bus-box-tiao-list {
        padding: 82px 82px 0 82px;
        .bus-box-tiao-item {
            margin-bottom: 32px;
        }
        .el-col-1 {
            width: 38px;
            height: 38px;
            line-height: 38px;
            background: #0052c2;
            border-radius: 7px;
            font-size: 24px;
            font-family: 'Impact';
            font-weight: 400;
            text-align: center;
            color: #ffffff;
        }
        .el-col-23 {
            font-size: 24px;
            font-weight: 600;
            color: #332e2c;
            line-height: 33px;
            padding-left: 20px;
        }
    }
}
.bus-box-partner {
    height: 806px;
    background: url('../../assets/images/bus-partner-bg.jpg') no-repeat center;
    width: 100%;
    background-size: cover;
    h3 {
        margin-top: 339px;
    }
    .bus-box-partner-list {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 60px;
        .el-col {
            width: 173px;
            height: 114px;
            background: #fff;
            border-radius: 5px;
            margin-bottom: 30px;
        }
        .el-col:not(:nth-child(6n)) {
            margin-right: 32px;
        }
    }
}
.bus-box-tips {
    background: url('../../assets/images/bus-people-bg.jpg') no-repeat center;
    width: 100%;
    height: 798px;
    background-size: cover;
    h3 {
        margin-top: 49px;
    }
    .bus-box-tips-img {
        width: $width;
        height: 580px;
        margin:$margin;
        margin-top: 32px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
}
.bus-box-service {
        background: url('../../assets/images/bus-service-bg.jpg') no-repeat center;
        background-size: cover;
        height: 1011px;
        margin-bottom: -56px;
        h3 {
            margin-top: 42px;
            color: #0054be;
        }
        .bus-box-service-list {
            width: $width;
            margin: $margin;
            margin-top: -10px;
            .el-col {
                width: 351px;
                position: relative;
                img {
                        position: relative;
                        left: 50%;
                        transform: translateX(-50%);
                        top: 63px;
                        z-index: 99;
                    }
                div {
                    width: 351px;
                    height: 326px;
                    background: #ffffff;
                    border-radius: 20px;
                    box-shadow: 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
                    backdrop-filter: blur(6px);
                    font-family: $font-family;
                    padding: 43px;
                    box-sizing: border-box;
                    h4 {
                        font-size: 30px;
                        font-weight: 700;
                        text-align: center;
                        color: #2c3331;
                        line-height: 36px;
                        margin-bottom: 24px;
                        margin-top: 50px;
                    }
                    p {
                        font-size: 22px;
                        font-weight: 400;
                        color: #5e6663;
                        line-height: 40px;
                        margin: 0;
                    }
                }
            }
        }
        .bus-box-order {
            @include gwidth;
            width: 1200px;
            height: 255px;
            background: linear-gradient(180deg,#ff9e4a, $common-color);
            border-radius: 20px;
            box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
            padding: 48px;
            margin-top: 110px;
            position: relative;
            margin-bottom: 28px;
            span {
                display: inline-block;
            }
            img {
                position: absolute;
                top:0;
                left: 0;
            }
            .bus-box-order-title {
                font-size: 36px;
                font-family: 'zihun443hao';
                color: #ffffff;
            }
            .bus-box-order-desc {
                font-size: 18px;
                font-weight: 500;
                color: #ffffff;
                margin-left: 24px;
            }
        }
    }
</style>